import React from 'react'

import agentConnection from '../../lib/eshift/agent'

export const AgentContext = React.createContext(null)

const AgentProvider = ({ children }) => {
  // Extract functions from object
  const functions = React.useMemo(() => {
    const funcs = {}

    Object.entries(agentConnection)
      .filter(entry => typeof entry[1] === 'function')
      .forEach(([key, val]) => {
        funcs[key] = val
      })

    return funcs
  }, [])

  return (
    <AgentContext.Provider value={functions}>{children}</AgentContext.Provider>
  )
}

export default AgentProvider

export const useAgent = () => React.useContext(AgentContext)
